qw-extra {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

qw-extra.qw-extra--loading {
  align-items: center;
}

qw-extra .qw-loader {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.8;
  pointer-events: none;
  z-index: 2000;
}

qw-extra .qw-loader:after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #eee;
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0) 12%,
    white 17%,
    rgba(255, 255, 255, 0) 22%
  );
  background-size: 600% 100%;
  background-position-x: 40%;
  animation: 3s shine linear infinite;
  opacity: 0.4;
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

qw-extra.loading-skeleton qw-extra-card {
  background-color: var(--qw-hotel-skeleton-light);
  box-shadow: none;
}

qw-extra.loading-skeleton qw-extra-card .qw-extra-card__image qw-image:after {
  content: '';
  display: block;
  width: 50%;
  height: 100%;
  border-radius: 2px;
  background-color: var(--qw-hotel-skeleton-medium);
}

qw-extra.loading-skeleton qw-extra-card .qw-extra-card__image img {
  display: none;
}

qw-extra.loading-skeleton qw-extra-card .qw-extra-card__title h4 {
  color: var(--qw-hotel-skeleton-dark);
  background-color: var(--qw-hotel-skeleton-dark);
  border-radius: 2px;
  display: inline-block;
}

qw-extra.loading-skeleton qw-extra-card .qw-extra-card__price {
  color: var(--qw-hotel-skeleton-medium);
  background-color: var(--qw-hotel-skeleton-medium);
  border-radius: 2px;
  width: auto;
}

qw-extra.loading-skeleton qw-extra-card .qw-extra-card__price-label,
qw-extra.loading-skeleton qw-extra-card .qw-extra-card__price-content {
  display: inline-block;
  color: var(--qw-hotel-skeleton-medium);
}

qw-extra.loading-skeleton qw-extra-card .qw-extra-card__detail-trigger {
  color: var(--qw-hotel-skeleton-medium);
  background-color: var(--qw-hotel-skeleton-medium);
  background-size: 0;
}
qw-extra.loading-skeleton qw-extra-card .qw-extra-card__footer select {
  color: var(--qw-hotel-skeleton-medium);
  background-color: var(--qw-hotel-skeleton-medium);
  background-size: 0;
  border-color: var(--qw-hotel-skeleton-medium);
}

qw-extra .qw-extra__card-wrapper {
  width: 100%;
}

qw-extra .qw-extra__card-wrapper-title {
  font-family: var(--qw-hotel-font-family-b);
  font-size: 30px;
  margin-bottom: var(--qw-hotel-gap-sm);
}

/* .skeleton-extra-title {
  width: 120px;
  height: 36px;
  margin-bottom: 12px;
  position: relative;
  background-color: var(--qw-hotel-skeleton-light);
} */
/* 
.skeleton-extra-title:after {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #eee;
  background: linear-gradient(110deg, rgba(255,255,255,0) 12%, white 17%, rgba(255,255,255,0) 22%);
  background-size: 600% 100%;
  background-position-x: 40%;
  animation: 3s shine linear infinite;
  opacity: 0.4;
} */

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

qw-extra .qw-extra__card-content {
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
  width: 100%;
}

qw-extra qw-extra-card {
  width: 100%;
  margin-right: 2%;
  margin-bottom: 2%;
  max-width: 32%;
  background: #ffffff;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  flex-direction: column;
  padding: 16px 26px 16px 23px;
}

qw-extra qw-extra-card:nth-child(3n + 3) {
  margin-right: 0;
}

qw-extra .qw-button {
  width: 30%;
}

@media only screen and (max-width: 1380px) {
  qw-extra qw-extra-card {
    width: 100%;
    margin-right: 2%;
    margin-bottom: 2%;
    max-width: 48%;
  }

  qw-extra qw-extra-card:nth-child(2n + 2) {
    margin-right: 0;
  }

  qw-extra qw-extra-card:nth-child(3n + 3) {
    margin-right: 2%;
  }
}

@media only screen and (max-width: 1024px) {
  qw-extra qw-extra-card {
    margin-right: 0;
    margin-bottom: 40px;
    max-width: 100%;
  }

  qw-extra qw-extra-card:nth-child(3n + 3) {
    margin-right: 0;
  }
}

@media only screen and (max-width: 738px) {
  qw-extra .qw-extra__card-wrapper-title {
    font-size: 20px;
    padding: 0 14px;
  }

  .qw-extra__warning {
    padding: 0 14px;
  }
}
